module.exports = __webpack_public_path__ + "static/media/statsIco3.8e8d91b1.svg";